import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { AdminCustomerInvoice } from "@/types/customer"

type AdminCustomerInvoicesState = {
  data: AdminCustomerInvoice[]
  error: string | null
}

export const adminCustomerInvoicesInitialState: AdminCustomerInvoicesState = {
  data: [],
  error: null,
}

const adminCustomerInvoicesSlice = createSlice({
  name: "adminCustomerInvoices",
  initialState: adminCustomerInvoicesInitialState,
  reducers: {
    setAdminCustomerInvoicesAction: (
      state,
      action: PayloadAction<AdminCustomerInvoice[]>,
    ) => {
      state.data = action.payload
      state.error = null
    },
    setAdminCustomerInvoicesErrorAction: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.error = action.payload
    },
  },
})

export const {
  setAdminCustomerInvoicesAction,
  setAdminCustomerInvoicesErrorAction,
} = adminCustomerInvoicesSlice.actions

export default adminCustomerInvoicesSlice.reducer
